
(function () {
    'use strict';
    angular
        .module('app.service')
        .factory('customerService', customerService);

    function customerService($http, $q, exception, logger, coreService, config, $odataresource, $odata) {
        var service = {
            getAllParentCustomersWithRegionsAreasAndSites: getAllParentCustomersWithRegionsAreasAndSites,
            getCustomerHierachyODataResource: getCustomerHierachyODataResource,
            getSitesForCorporate: getSitesForCorporate,
            getCorporateForSites: getCorporateForSites,
            getParentCustomersWithRegionsAreasAndSites: getParentCustomersWithRegionsAreasAndSites,
            getAllCustomers: getAllCustomers,
            getMatchedCustomers: getMatchedCustomers,
            getCustomer: getCustomer,
            getCustomerLocations: getCustomerLocations,
            getCustomerODataResource: getCustomerODataResource,
            getCustomerSitesByCustomerId: getCustomerSitesByCustomerId,
            getSimiliarCustomer: getSimiliarCustomer,
            savePendingCustomer: savePendingCustomer,
            getCustomerLocationTableState: getCustomerLocationTableState,
            checkIfCustomerExists: checkIfCustomerExists,
            getCorporateForSitesWithParentCustomer: getCorporateForSitesWithParentCustomer
        };

        activate();

        return service;

        function activate() {
        }

        //cal api endpoint
        function getAllParentCustomersWithRegionsAreasAndSites() {
            return coreService.httpGet(config.sharedDataApiUrl,
                'api/Corporate');
        }

        function getParentCustomersWithRegionsAreasAndSites(corporateId) {
            return coreService.httpGet(config.sharedDataApiUrl, 'api/Corporate/' + encodeURIComponent(corporateId));
        }

        function getCustomerHierachyODataResource() {
            return $odataresource(config.sharedDataApiUrl + 'odata/CustomerHierarchyTie',
                {},
                {},
                {
                    odatakey: 'CustomerHierarchyTieId',
                    isodatav4: true
                });
        }

        function getCustomerODataResource() {
            return $odataresource(config.sharedDataApiUrl + 'odata/Customer',
                {},
                {},
                {
                    odatakey: 'CustomerHierarchyTieId',
                    isodatav4: true
                });
        }

        function getSSOCustomerOdataResource() {
            return $odataresource(config.apiUrl + 'odata/Customers',
                {},
                {},
                {
                    odatakey: 'CustomerId',
                    isodatav4: true
                });
        }

        function getCorporateForSites(siteId, hierarchyId) {
            var query = getCustomerHierachyODataResource().odata();
            query = query
                .filter('ChildCustomerId', siteId);
            query.filter('HierarchyId', hierarchyId);
            return query
                .withInlineCount()
                .query()
                .$promise;
        }

        function getCorporateForSitesWithParentCustomer(siteId, hierarchyId) {
            var query = getCustomerHierachyODataResource().odata();
            query = query.expand('ParentCustomer');
            query = query
                .filter('ChildCustomerId', siteId);
            query.filter('HierarchyId', hierarchyId);
            return query
                .withInlineCount()
                .query()
                .$promise;
        }

        function getSitesForCorporate(corporateId, hierarchyId, searchTerm, page, count) {
            var query = getCustomerHierachyODataResource().odata();
            query = query
                .expand('ChildCustomer');


            coreService.processODataPage(query, { start: (page * count), number: count });

            if (!searchTerm) {
                query.filter(new $odata.Func('contains',
                    new $odata.Property('ChildCustomer/CustomerDisplayName'), searchTerm));
            }

            query
                .filter('ParentCustomerId', corporateId);

            query.filter('HierarchyId', hierarchyId);

            query.filter('ChildCustomer/Deleted', false);
            query.filter('ChildCustomer/MostPurchasedTruckSeries', '!=', new $odata.Property('null'));

            return query
                .withInlineCount()
                .query()
                .$promise
                .then(function (result) {
                    var mapperArr = result.filter(function (site) {
                        return !!site.ChildCustomer;
                    }).map(function (site) {
                        return {
                            SiteId: site.ChildCustomer.CustomerID,
                            StateId: site.ChildCustomer.StateId,
                            SiteName: site.ChildCustomer.CustomerDisplayName,
                            Latitude: site.ChildCustomer.Latitude,
                            Longitude: site.ChildCustomer.Longitude
                        };
                    });
                    mapperArr.count = result.count;
                    return mapperArr;
                });
        }

        function getCustomer(CustomerId) {
            var query = getCustomerODataResource().odata();
            query.filter('CustomerID', CustomerId);

            return query
                .query()
                .$promise;
        }

        function getCustomerLocations(tableState) {
            var query = getCustomerODataResource().odata();

            if (!!tableState) {
                tableState.pagination.number = 5;
                coreService.processODataFilters(query, tableState.search.predicateObject,
                    getCustomerLocationTableState().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
                tableState.pagination.number = 5;
            }
            
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                predicate: 'Address1', reverse: false
            };
            
            coreService.processODataSort(query, tableState.sort);

            return query
                .filter('CustomerID', '>', 0)
                .filter('CustomerStatus/CustomerStatusCode', 'AC')
                .select('CustomerID', 'Name', 'Address1', 'City', 'State', 'ZIPCode', 'Country',
                    'CustomerDisplayName')
                .expand('State')
                .expand('Country')
                .withInlineCount()
                .query()
                .$promise.then(function (response) {                    
                    var mappedResponse = response.map(function (location) {
                        if (!location.State) {
                            location.State = { StateCode: '' };
                        }

                        return location;
                    });

                    mappedResponse.count = response.count;
                    return mappedResponse;
                });            
        }

        function getAllCustomers(searchTerm, page, count) {
            var query = getCustomerODataResource().odata();

            coreService.processODataPage(query, { start: (page * count), number: count });

            if (!searchTerm) {
                query.filter(new $odata.Func('contains',
                    new $odata.Property('CustomerDisplayName'),
                    new $odata.Value(searchTerm)));

            }

            return query
                .withInlineCount()
                .select('CustomerID', 'CustomerDisplayName', 'Name')
                .take(10)
                .query()
                .$promise;
        }

        function getCustomerSitesByCustomerId(customerId) {
             var url = 'customer/CustomerSitesByCustomerId/' + customerId;
            return coreService.httpAccountsGet(url);
        }

        function savePendingCustomer(pendingCustomer) {
            var url = coreService.httpPost(config.sharedDataApiUrl,
                '/api/pendingcustomer/savecustomer', pendingCustomer);
        }

        function getSimiliarCustomer(customer) {
            return coreService.httpGet(config.sharedDataApiUrl, '/api/CustomerManagement/SimilarCustomers');
        }

        function getMatchedCustomers(searchTerm, page, count) {
            var query = getSSOCustomerOdataResource().odata();

            coreService.processODataPage(query, { start: (page * count), number: count });

            if (!!searchTerm) {
                query.filter(new $odata.Func('contains',
                    new $odata.Property('CustomerDisplayName'),
                    new $odata.Value(searchTerm)));

            }

            return query
                .withInlineCount()
                .expand('CustomerTypeTie')
                .expand('CustomerTypeTie', 'CustomerType')
                .take(10)
                .query()
                .$promise.then(function (results) {
                    return results.map(function (cust) {
                        var isDistributor = false;
                        var customerTypes = cust.CustomerTypeTie.map(function (customerType) {
                            return customerType.CustomerType;
                        });

                        var orderedByPrecedence = _.sortBy(customerTypes, 'SortOrder');
                        var customerType = _.first(orderedByPrecedence);
                        if (customerType) {
                            isDistributor = customerType.CustomerTypeCode === 'DI';
                        }                        

                        return {
                            CustomerID: cust.CustomerID,
                            CustomerDisplayName: cust.CustomerDisplayName,
                            Name: cust.Name,
                            IsDistributor: isDistributor
                        };
                    });
                });
        }

        function getCustomerLocationTableState(callback) {
            return {
                columns: [
                    {
                        id: 'CustomerID',
                        displayName: 'Id',
                        ODataKey: 'CustomerID',
                        type: 'guid',
                        style: {
                            col_width: '1'
                        }
                    },
                    {
                        id: 'Name',
                        displayName: 'Customer Name',
                        ODataKey: 'Name',
                        type: 'match',
                        style: {
                            col_width: '2'
                        }
                    },
                    {
                        id: 'Address1',
                        displayName: 'Address',
                        ODataKey: 'Address1',
                        type: 'match',
                        style: {
                            col_width: '2'
                        }
                    },
                    {
                        id: 'City',
                        displayName: 'City',
                        ODataKey: 'City',
                        type: 'match',
                        style: {
                            col_width: '2'
                        }
                    },
                    {
                        id: 'State',
                        displayName: 'State',
                        ODataKey: 'State/StateCode',
                        type: 'subItem',
                        style: {
                            col_width: '1'
                        }
                    },
                    {
                        id: 'ZIPCode',
                        displayName: 'ZIP Code',
                        ODataKey: 'ZIPCode',
                        type: 'match',
                        style: {
                            col_width: '2'
                        }
                    },
                    {
                        id: 'Country',
                        displayName: 'Country',
                        ODataKey: 'Country/CountryCodeISO3',
                        type: 'subItem',
                        style: {
                            col_width: '1'
                        }
                    }
                ],
                custom: {
                    action: {
                        options: {
                            btnClass: 'btn-success',
                            callback: callback,
                            hasIcon: true,
                            icon: 'fa-plus',
                            label: 'Select'
                        }
                    },
                    showFilter: true,
                    pagination: {
                        rowsPerPage: 5
                    }
                },                
                actions: []
            };
        }

        function checkIfCustomerExists(fromCustomerId, toCustomerId) {
            var predicate1 = new $odata.Predicate('CustomerID', fromCustomerId);
            var predicate2 = new $odata.Predicate('CustomerID', toCustomerId);
            var combination = $odata.Predicate.or([predicate1, predicate2]);
            var query = getSSOCustomerOdataResource().odata();

            return query
                .filter(combination)
                .query()
                .$promise;
        }
    }
})();
